import API from "../../api";
let token = localStorage.getItem("token");

export const getHeatmapTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getHeatmapDropdownDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const updateHeatmapFormDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getHeatmapFormTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getVishingDropdownDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const updateVishingFormDataService = (requestUrl,id) => {
    return API.post(requestUrl, id, {
      headers: {
        Authorization: token,
      },
    })
      .then((resp) => resp)
      .catch((error) => error.response);
  };

  export const getVishingFormTableDataService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};

export const getVishingValidateTicketNoService = (requestUrl) => {
    return API.get(requestUrl, {
      headers: {
        Authorization: token,
    }})
      .then((resp) => resp)
      .catch((error) => error.response);
};